import axiosInstance from "../axios";
import { baseURLGame, BANIBONS } from "../../utils/endPoints";
import { banibonAction } from "./slice";
export const getBanibons = function (token: string) {
  return async (dispatch: Function) => {
    try {
      dispatch(banibonAction.setLoadingBanibon(true));
      const config = {
        url: `${baseURLGame}${BANIBONS}`,
        method: "GET",
        timout: 0,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axiosInstance(config);
      dispatch(banibonAction.setBanibons(response.data));
    } catch (error) {}
  };
};
